import fromPairs from 'lodash/fromPairs';

import {reporter} from './../error-reporting';
import experimentsClient from './../queries/app-api/experiments-client';
import messageVariantsClient from './../queries/app-api/message-variants-client';
import {getPropertyValueMappings, isBrowserEnvironment, updatePropertyValueMappings} from './index';

/**
 * Returns the promise for loading project mappings
 */
export function getReportPropertyValueMappingsPromise(): Promise<any> {
  return (window as any).__propertyMappingsPromise || null;
}

/**
 * Updates all property value mappings from different sources
 * prevents querying multiple times to avoid overwritting mappings
 */
export async function syncReportPropertyValueMappings(
  projectID: number,
  {projectCampaigns = []}: {projectCampaigns?: Array<[number, string]>} = {},
  workspaceId = 0,
  forceQuery = false,
) {
  const mappingsPromise = getReportPropertyValueMappingsPromise();

  if (mappingsPromise !== null && !forceQuery) {
    return await mappingsPromise;
  }

  const mappings = {
    ...getPropertyValueMappings(),
    ...(projectCampaigns.length ? {projectCampaigns: fromPairs(projectCampaigns)} : {}),
  };

  const messagesVariantsRequestPromise = messageVariantsClient
    .query({projectID, workspaceId})
    .catch((err) => {
      reporter.error(new Error(`Error loading messages variants mappings`), err);
      return {campaignVariants: []};
    })
    .then((campaignVariants) => ({campaignVariants}));

  const experimentsRequestPromise = experimentsClient
    .query({projectID, workspaceId})
    .catch((err) => {
      reporter.error(new Error(`Error loading experiment mappings`), err);
      return {experiments: []};
    })
    .then((experiments) => ({experiments}));

  const requestPromise = Promise.all([messagesVariantsRequestPromise, experimentsRequestPromise]);

  if (isBrowserEnvironment()) {
    (window as any).__propertyMappingsPromise = requestPromise;
  }

  const results = await requestPromise;
  updatePropertyValueMappings(Object.assign(mappings, ...results));
}
